import { NavMainItem } from "../Interface/NavBar";

// Utility function to handle opening windows
export function openWindowsForItem(item: NavMainItem) {
	// Open the main window
	window.open(
		item.url,
		"_blank",
		"width=1200,height=800,scrollbars=yes,resizable=yes",
	);

	// Open any additional windows
	if (item.additionalWindows) {
		item.additionalWindows.forEach((additionalWindow, index) => {
			// Offset each additional window slightly so they don't overlap
			const offsetX = (index + 1) * 50;
			const offsetY = (index + 1) * 50;
			window.open(
				additionalWindow.url,
				"_blank",
				`width=1200,height=800,scrollbars=yes,resizable=yes,left=${offsetX},top=${offsetY}`,
			);
		});
	}
}
